const fakeBookings = [
  {
    _id: "bk001",
    bookingDate: "2025-06-01T09:00:00Z",
    serviceCart: [{ service: { name: "Limpieza profunda" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 150,
      paymentMethod: "Tarjeta",
      status: "Pagado",
    },
    createdFrom: "App móvil",
    status: "Finalizado",
    feedbackInfo: { rating: 5 },
    isInBranch: false,
    branch: { name: "Sucursal Central" },
  },
  {
    _id: "bk002",
    bookingDate: "2025-06-02T14:30:00Z",
    serviceCart: [{ service: { name: "Corte de cabello" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 50,
      paymentMethod: "Efectivo",
      status: "Pendiente",
    },
    createdFrom: "Web",
    status: "Pendiente",
    feedbackInfo: { rating: 4 },
    isInBranch: true,
    branch: { name: "Sucursal Norte" },
  },
  {
    _id: "bk003",
    bookingDate: "2025-06-03T11:00:00Z",
    serviceCart: [{ service: { name: "Manicure" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 80,
      paymentMethod: "QR",
      status: "Pagado",
    },
    createdFrom: "App móvil",
    status: "Confirmado",
    feedbackInfo: { rating: 5 },
    isInBranch: false,
    branch: { name: "Sucursal Este" },
  },
  {
    _id: "bk004",
    bookingDate: "2025-06-04T16:45:00Z",
    serviceCart: [{ service: { name: "Pintura de uñas" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 40,
      paymentMethod: "Tarjeta",
      status: "Pagado",
    },
    createdFrom: "Web",
    status: "En proceso",
    feedbackInfo: { rating: 3 },
    isInBranch: true,
    branch: { name: "Sucursal Sur" },
  },
  {
    _id: "bk005",
    bookingDate: "2025-06-05T13:15:00Z",
    serviceCart: [{ service: { name: "Masaje relajante" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 200,
      paymentMethod: "Efectivo",
      status: "Pagado",
    },
    createdFrom: "App móvil",
    status: "Finalizado",
    feedbackInfo: { rating: 5 },
    isInBranch: false,
    branch: { name: "Sucursal Central" },
  },
  {
    _id: "bk006",
    bookingDate: "2025-06-06T10:00:00Z",
    serviceCart: [{ service: { name: "Limpieza facial" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 100,
      paymentMethod: "QR",
      status: "Pendiente",
    },
    createdFrom: "Web",
    status: "Pendiente",
    feedbackInfo: { rating: null },
    isInBranch: true,
    branch: { name: "Sucursal Norte" },
  },
  {
    _id: "bk007",
    bookingDate: "2025-06-07T17:00:00Z",
    serviceCart: [{ service: { name: "Depilación láser" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 180,
      paymentMethod: "Tarjeta",
      status: "Pagado",
    },
    createdFrom: "App móvil",
    status: "Confirmado",
    feedbackInfo: { rating: 4 },
    isInBranch: false,
    branch: { name: "Sucursal Este" },
  },
  {
    _id: "bk008",
    bookingDate: "2025-06-08T15:00:00Z",
    serviceCart: [{ service: { name: "Pedicure spa" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 90,
      paymentMethod: "Efectivo",
      status: "Pagado",
    },
    createdFrom: "Web",
    status: "Finalizado",
    feedbackInfo: { rating: 5 },
    isInBranch: true,
    branch: { name: "Sucursal Sur" },
  },
  {
    _id: "bk009",
    bookingDate: "2025-06-09T12:00:00Z",
    serviceCart: [{ service: { name: "Tratamiento capilar" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 130,
      paymentMethod: "QR",
      status: "Pagado",
    },
    createdFrom: "App móvil",
    status: "En proceso",
    feedbackInfo: { rating: null },
    isInBranch: false,
    branch: { name: "Sucursal Central" },
  },
  {
    _id: "bk010",
    bookingDate: "2025-06-10T08:30:00Z",
    serviceCart: [{ service: { name: "Peinado" } }],
    paymentInfo: {
      coupon: { name: "N/A" },
      totalPrice: 60,
      paymentMethod: "Tarjeta",
      status: "Pendiente",
    },
    createdFrom: "Web",
    status: "Pendiente",
    feedbackInfo: { rating: 3 },
    isInBranch: true,
    branch: { name: "Sucursal Norte" },
  },
];

export default fakeBookings;
